"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaListQuerySchema = exports.mediaUploadResponseSchema = exports.mediaSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — mirrors Prisma Media model exactly
exports.mediaSchema = zod_1.z.object({
    id: zod_1.z.string(),
    filename: zod_1.z.string(),
    originalName: zod_1.z.string(),
    mimeType: zod_1.z.string(),
    size: zod_1.z.number(),
    url: zod_1.z.string(),
    bucket: zod_1.z.string(),
    alt: zod_1.z.string(),
    folder: zod_1.z.string().default("general"),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.mediaUploadResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    url: zod_1.z.string().url(),
    filename: zod_1.z.string(),
    originalName: zod_1.z.string(),
    mimeType: zod_1.z.string(),
    size: zod_1.z.number(),
    bucket: zod_1.z.string(),
});
exports.mediaListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(20),
    search: zod_1.z.string().optional(),
    mimeType: zod_1.z.string().optional(),
    folder: zod_1.z.string().optional(),
});
//# sourceMappingURL=media.js.map